import { classNames } from "src/helpers/classNames";

const toneClasses = { default: "text-gray-900", warn: "text-amber-600", bad: "text-red-600" };
const barClasses = { default: "bg-green-500", warn: "bg-amber-500", bad: "bg-red-500" };

// A metric tile. With `percent`, a progress bar is shown and the value turns amber at `warnAt` and red at `badAt`;
// without it, `tone` sets the colour directly.
const StatTile = ({ label, value, percent = null, detail = null, warnAt = 80, badAt = 90, tone = null }) => {
  const level = tone || (percent == null ? "default" : percent >= badAt ? "bad" : percent >= warnAt ? "warn" : "default");
  return (
    <div className="flex flex-col gap-1 rounded-md border border-gray-100 bg-gray-50/60 px-4 py-3">
      <span className="text-xs font-medium uppercase tracking-wide text-gray-400">{label}</span>
      <span className={classNames("text-lg font-semibold", toneClasses[level])}>{value}</span>
      {percent != null && (
        <div
          className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200"
          aria-hidden="true">
          <div
            className={classNames("h-full rounded-full", barClasses[level])}
            style={{ width: `${Math.max(0, Math.min(100, percent))}%` }}
          />
        </div>
      )}
      {detail && <span className="text-xs text-gray-400">{detail}</span>}
    </div>
  );
};

export default StatTile;
